module.exports = __webpack_public_path__ + "img/flame.56f987a3.svg";